import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/recursos_humanos/isr';
import ListIsr from './ListISR';


const ms2p = (state) => {
  return {
    ...state.isr_rh,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ListIsr);